import { onlineStatus } from '../checks/onlineStatus.js';
import type { RolesWithPermissions } from '../permissions.js';

export const support: RolesWithPermissions['support'] = {
  permissions: {
    OSCEs: { viewnew: false, viewratedonce: false, create: false, modify: false, delete: false },
    instructionCategories: { view: false },
    answers: {
      createempty: false,
      modifyaudio: false,
      modifytranscript: false,
      create: true,
      modify: false,
      delete: false,
    },
    examdays: {
      view: false,
      create: false,
      modify: false,
      modifymissingcandidates: false,
      schedule: false,
      printcandiates: false,
      sendinfomail: false,
      viewselect: true,
      operate: false,
      viewstatistics: false,
      delete: false,
    },
    finalratings: { view: false, create: false, modify: false, delete: false },
    invoices: { create: true, view: true },
    mails: { modify: true, view: true, create: false, delete: false },
    orders: {
      createmanual: true,
      modify: true,
      modifycomment: true,
      move: true,
      revoke: true,
      setpaid: true,
      view: true,
      create: true,
    },
    results: { sendmail: false, view: false },
    certificates: { sendmail: false, view: false },
    ratings: {
      modifyownnotes: false,
      view: true,
      viewoverview: true,
      viewothers: false,
      create: false,
      modify: false,
      delete: false,
    },
    shortTokens: { view: false, create: false, modify: false, delete: false },
    slots: {
      createfallback: false,
      extend: false,
      rate: false,
      view: false,
      viewothers: false,
      delete: false,
      spectate: false,
      modifycomment: false,
      usefallbackactor: false,
      create: false,
      modify: false,
    },
    timeline: {
      view: true,
      viewadmin: true,
    },
    users: { create: false, modify: true, modifyassignedosces: false, view: true, delete: false, impersonate: false },
    reportedErrors: { create: false, view: false, resolve: false },
    termins: { create: false, view: false, schedule: false },
    timeslots: { view: false, create: false, delete: false },
    osceGroups: { create: false, modify: false, delete: false },
    scores: { create: false, modify: false, delete: false },
    eventLogs: { create: true, modify: true, delete: false },
    files: { create: true, modify: true, delete: false },
    onlineStatus,
    counters: { create: true, modify: true, delete: false },
    dataViewConfigs: { create: true, modify: true, delete: false },
    examDayReservations: { create: true, modify: true, delete: true },
    locations: { create: false, modify: false, delete: false, view: false },
  },
  allowedPages: { users: 1, mails: 1, 'evaluation-overview': 1, scheduling: 1, 'editor-exam': 1 },
  examDayFilter: user => {
    return { archived: { $ne: true } };
  },
};
